import { render, staticRenderFns } from "./PersonViolationRecord.vue?vue&type=template&id=53a736b5&scoped=true"
import script from "./PersonViolationRecord.vue?vue&type=script&lang=js"
export * from "./PersonViolationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a736b5",
  null
  
)

export default component.exports